import { FunctionComponent } from 'react';
import { ImportCustomDirectPage } from '.';

export const ImportCustomFilesDirect: FunctionComponent = () => {
	return <ImportCustomDirectPage />;
};
